/** The shared primitives: the confirm dialog, the name prompt, the context menu. */

export const ui = {
  confirmDefault: 'OK',
};
